import React from "react";
import NavAdmin from "../../nav-admin/nav-admin";
import DirectEmailIcon from "../../../assets/images/svg-icons-material-io/mail_lock_black_24dp.svg";
import useUserStore from "../../../utils/storeApp";

const HeaderWelcome = () => {
  const { userRole } = useUserStore((state) => ({
    userRole: state.userRole,
  }));
  return (
    <header className="HeaderWelcome" role="banner">
      {userRole === "SES ADMINISTRATOR" ||
      userRole === "ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR" ? (
          <nav 
            className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar" 
            aria-label="Direct administration header bar with admin navigation"
         >
            <div className="container w-max2">
              <h5 className="sp-mx" id="welcome-header-title">
                <img
                  src={DirectEmailIcon}
                  className="filter-white"
                  alt=""
                  aria-hidden="true"
                />{" "}
                <span className="sp-margin12 v-set4">DIRECT</span>
              </h5>
              <NavAdmin />
            </div>
          </nav>
      ) : null}
    </header>
  );
};

export default HeaderWelcome;
